import React from "react";

import { Globe2 } from "lucide-react";

import PageHeader from "../../Components/PageHeader";

/**
 * Ops entry point — live briefings load from Always On / Account Synopsis via
 * POST /account-briefings with explicit EB account ids.
 */
const XFactorBriefings: React.FC = () => {
  return (
    <div className="mt-3 flex min-h-0 flex-col bg-white">
      <PageHeader title="Business Health Briefing" icon={Globe2} />

      <div className="w-full flex-1 bg-white p-3 md:p-4">
        <div className="mx-auto max-w-2xl rounded-lg border border-gray-200 bg-white px-4 py-10 text-center">
          <p className="text-sm text-gray-600">
            Briefings load per EB account id through{" "}
            <code className="rounded bg-gray-100 px-1 text-xs">
              POST /api/v1/xfactor-briefings/account-briefings
            </code>
            . Use Always On → Business Health or Account Synopsis — not{" "}
            <code className="rounded bg-gray-100 px-1 text-xs">
              account_scope=all
            </code>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default XFactorBriefings;
